import SpellsLevel from "./SpellsLevel";

export default SpellsLevel;
export { SpellsLevel };
